import { Link } from 'react-router-dom';

const stats = [
  { value: '1,280+', label: '收录影音资源' },
  { value: '4', label: '内容分类频道' },
  { value: '每日', label: '资源更新频率' },
  { value: '100%', label: '国语对白内容' },
];

export default function SiteIntro() {
  return (
    <section className="mx-auto w-full px-4 md:px-8">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-7 md:p-10">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-label text-secondary-900">
              <i className="ri-information-line" />
              关于本站
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              专注国语对白的高清影音资源集合
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              国语对白做受69 旨在为喜爱国语影视的观众、研究者提供一站式的资源查询与浏览体验。
              我们把电影、电视剧、纪录片、综艺等不同类型的国语影音作品集中收录，
              通过多维分类、关键词搜索与相关推荐，帮助你更快地找到想看的内容、了解作品的详细信息。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              本站内容均为整理与展示用途，资源信息以条目形式呈现，方便检索与浏览。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="inline-flex h-10 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 text-sm font-label text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-information-line" />
                了解更多
              </Link>
              <Link
                to="/search"
                className="inline-flex h-10 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 text-sm font-label text-foreground-800 transition-colors hover:bg-background-100"
              >
                <i className="ri-search-line" />
                搜索资源
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 border-t border-background-200 bg-primary-900 lg:border-l lg:border-t-0">
            {stats.map((item) => (
              <div
                key={item.label}
                className="flex flex-col justify-center gap-1 border-background-100/10 p-7 md:p-8 [&:nth-child(odd)]:border-r [&:nth-child(-n+2)]:border-b"
              >
                <span className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">
                  {item.value}
                </span>
                <span className="text-sm text-background-200/90">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}